import React, { Component } from "react";
import { connect } from "react-redux";
import {Grid, Typography, Fab, Button} from "@material-ui/core";
import { Add } from "@material-ui/icons";

import styles from "./style";
import { parentContainer } from "../../config/theme";
import Breadcrumbs from "../../components/Breadcrumbs";
import DishesList from "../../components/Dishes/DishesList";
import PostsList from "../../components/Posts/PostsList";
import Header from "../../components/Header";
import Footer from "../../components/Footer/FooterChefSteps";
import { GET_CHEF_DETAILS } from "../../graphql/queries/chef";
import { CUISINES } from "../../graphql/queries/dishes";
import { compose, graphql } from "react-apollo";
import { setViewAsDiner } from '../../redux/user';

class Portfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updatedAt: Date.now()
    };
  }

  componentDidMount() {
    const { isChef } = this.props;

    if (!isChef) {
      this.props.history.push("/home/dashboard");
    }
  }

  addNewDish = () => {
    this.props.history.push("/home/add-dish?destination=portfolio", {
      previousRoute: "/home/dashboard"
    });
  };

  addNewPost = () => {
    this.props.history.push("/home/add-post");
  };

  showChefProfile = () => {
    const { userId: chefId, dispatch } = this.props;
    dispatch(setViewAsDiner(true));
    this.props.history.push("/home/chef-profile", { chefId, d: Date.now(), viewAsDiner: true});
  };

  editPortfolio = () => {
    const { details, cuisinesList } = this.props;
    details.refetch().then(res => {
      if (!res.error) {
        if (res.data) {
          const {
            data: { chef }
          } = res;


          this.props.history.push("/home/edit-portfolio", {
            step: 8,
            hideSteps: true,
            chef: chef || null,
            media: chef.media,
            selected: chef
              ? chef.cuisines.map(c => {
                  return { name: c, selected: true };
                })
              : [],
            cuisines: cuisinesList.cuisines || []
          });
        }
      }
    });
  };

  render() {
    const { details } = this.props;
    let isError = false;
    let errors = [];

    if (details) {
      if (details.chef) {
        if (details.chef.stripeStatus && details.chef.stripeErrors) {
          if (details.chef.stripeStatus !== 'VERIFIED') {
            isError = true;
            errors = details.chef.stripeErrors.filter((v,i,a)=>a.findIndex(v2=>(v2.code===v.code))===i);
          }
        }
      }
    }


    return (
      <div style={parentContainer}>
        <Grid container justify={'center'}>
          <Grid item xs={12}>
            <Header history={this.props.history} {...this.props} />
          </Grid>

          <Grid className="dish-container-custom" container style={{ padding: 20, marginTop: 40 }}>
            <Grid
              className="dish-edit-container"
              item
              xs={12}
              sm={12}
              style={{
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <div className="portfolio-breadcrumb-parent">
                <Breadcrumbs childRoutes={[]} />
              </div>
              <div>
                <Button
                  data-test-id="edit-pf"
                  variant="contained"
                  color="primary"
                  style={{ ...styles.topButton, ...styles.setFont}}
                  onClick={this.editPortfolio.bind(this)}
                >
                  Edit portfolio
                </Button>

                <Button
                  data-test-id="viewasdiner"
                  variant="contained"
                  color="primary"
                  style={{
                    ...styles.setFont,
                    ...styles.topButton,
                    marginLeft: 20
                  }}
                  onClick={this.showChefProfile.bind(this)}
                >
                  View as a diner
                </Button>
              </div>
            </Grid>

            {isError && <Grid container alignItems="flex-start" justify="flex-start" style={{ marginBottom: 30, color: 'red' }}>
              <Grid item xs={12} style={{ fontWeight: '500' }}>
                <p style={{ width: '100%', textAlign: 'center' }}>Please resolve the following errors on your profile.</p>
                </Grid><br />
              <ul className="stripe-chef-errors-wrapper">
                {errors.map(stripeErr => (
                  <li>{stripeErr.reason}</li>
                ))}
              </ul>
            </Grid>}

            <Grid container alignItems="flex-start">
              <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 20 }} />
              <Grid item xs={6} md={4} lg={4} xl={2}
                    style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                <Typography variant="h5" style={{
                  ...styles.setFont,
                  ...styles.heavy,
                  ...styles.headerFont,
                  textAlign: 'center'
                }}>
                  My Dishes
                </Typography>
                <button
                  data-test-id={"pf-dish"}
                  size="small"
                  style={{
                    ...styles.whiteFont,
                    boxShadow: 'none',
                    textTransform: 'none',
                    backgroundColor: '#ff8000',
                    borderRadius: 20,
                    borderColor: '#ff8000',
                    border: 'none',
                    width: 170, height: 30,
                    marginTop: 10
                  }}
                  onClick={this.addNewDish}
                >
                  Add new dish
                </button>
              </Grid>
              <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 20 }}  />
            </Grid>
            <Grid container className="dish-container-row">
              <Grid
              container>
                {this.props.userId && (
                  <DishesList
                    type="dishesByChef"
                    pageSize={8}
                    isLiveShow={false}
                    isShowAll={true}
                    filters={{ chefId: this.props.userId }}
                    next={null}
                    previous={null}
                    {...this.props}
                    updatedAt={this.state.updatedAt}
                    page={'Portfolio'}
                    addDishClick={this.addNewDish}
                  />
                )}
              </Grid>

              <Grid container alignItems="flex-start" style={{ marginTop: 30 }}>
                <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 20 }} />
                <Grid item xs={6} md={4} lg={4} xl={2}
                      style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                  <Typography variant="h5" style={{
                    ...styles.setFont,
                    ...styles.heavy,
                    ...styles.headerFont,
                    textAlign: 'center'
                  }}>
                    My Posts
                  </Typography>
                  <button
                    data-test-id={"pf-post"}
                    size="small"
                    style={{
                      ...styles.whiteFont,
                      boxShadow: 'none',
                      textTransform: 'none',
                      backgroundColor: '#ff8000',
                      borderRadius: 20,
                      borderColor: '#ff8000',
                      border: 'none',
                      width: 170, height: 30,
                      marginTop: 10
                    }}
                    onClick={this.addNewPost}
                  >
                    Add new post
                  </button>
                </Grid>
                <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 20 }}  />
              </Grid>
              <Grid container>
                {this.props.userId && (
                  <PostsList
                    pageSize={4}
                    filters={{ chefId: this.props.userId }}
                    next={null}
                    isShowAll={true}
                    previous={null}
                    page="portfolio"
                    updatedAt={Date.now()}
                    addPostClick={this.addNewPost}
                    {...this.props}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>

          <Footer />
        </Grid>
      </div>
    );
  }
}

const PortfolioWithData = compose(
  graphql(CUISINES, {
    name: "cuisinesList",
    options: props => ({
      variables: {
        country: "US"
      }
    })
  }),
  graphql(GET_CHEF_DETAILS, {
    name: "details",
    options: props => ({
      variables: {
        id: props.userId
      },
      fetchPolicy: 'network-only'
    })
  })
)(Portfolio);
const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    forceChangePassword: state.auth.forceChangePassword,
  };
};

const ChefPortfolio = connect(mapStateToProps)(PortfolioWithData);

export default ChefPortfolio;
